const asText = value => (value == null ? '' : String(value).trim());

const asDigits = value => asText(value).replace(/\D/g, '');

export const formatLeadPhone = (areaCode, phone) => {
  const area = asText(areaCode);
  const number = asText(phone);

  if (!number) return '';
  if (!area) return number;

  const areaDigits = asDigits(area);
  const numberDigits = asDigits(number);

  if (areaDigits && numberDigits.indexOf(areaDigits) === 0) {
    return numberDigits;
  }

  return `${areaDigits}${numberDigits}`;
};

export const getLeadPhoneLines = lead => {
  const entity = lead || {};
  const lines = [];
  const phone = formatLeadPhone(entity.phone_area_code, entity.phone);
  const mobilePhone = formatLeadPhone(entity.mobile_phone_area_code, entity.mobile_phone);

  if (phone) lines.push({ type: 'phone', value: phone });
  if (mobilePhone) lines.push({ type: 'mobile_phone', value: mobilePhone });

  return lines;
};

export const formatLeadPhones = lead => (
  getLeadPhoneLines(lead).map(line => line.value).join(' / ') || '-'
);
